import { createFileRoute } from "@tanstack/react-router";

import { AccountManagementDashboard } from "../tools/dashboards/AccountManagementDashboard";

function AccountManagementRoute() {
  return <AccountManagementDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/account-management")({
  component: AccountManagementRoute,
});
